
const NotFound = () => {
    return (
        <h1 className="m-0">404 | Page Not Found</h1>
    )
}
export default NotFound;